import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

function set_quantity_input_max_attribute(product_inventory_component) {
    const quantityComponentSelector = document.getElementsByTagName('quantity-selector-component');
    const quantityInput = quantityComponentSelector[0]?.getElementsByTagName('input')?.[0]

    if (quantityInput && product_inventory_component.dataset.productQuantity) {
        quantityInput.value = "1";
        quantityInput.setAttribute('max', product_inventory_component.dataset.productQuantity)
    }
}

class ProductInventory extends Component {
    connectedCallback() {
        super.connectedCallback();
        const closestSection = this.closest('.shopify-section, dialog');
        closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);

        set_quantity_input_max_attribute(this)
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        const closestSection = this.closest('.shopify-section, dialog');
        closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
    }

    /**
     * Updates the inventory.
     * @param {VariantUpdateEvent} event - The variant update event.
     */
    updateInventory = (event) => {
        if (event.detail.data.newProduct) {
            this.dataset.productId = event.detail.data.newProduct.id;
        } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
            return;
        }

        const newInventory = event.detail.data.html.querySelector('product-inventory');

        set_quantity_input_max_attribute(newInventory)

        if (!newInventory) return;

        morph(this, newInventory, { childrenOnly: true });
    };
}

if (!customElements.get('product-inventory')) {
    customElements.define('product-inventory', ProductInventory);
}
